import { ChartType, DataWidget } from 'types/dashboard_widget';
import { Dashboard } from 'types/dashboard';

/**
 * Migrates filters to a new format that got introduced with SC-9589.
 * A flat array of implicitly AND linked filters becomes `[{ ...rootFilter, and: [...allOtherFilters]}]`.
 * {@link https://app.shortcut.com/lumeo/story/9589/add-metrics-or-filtering-and-filter-groups-support}
 */
export function migrateDataWidgetFilters(dashboard: Dashboard): Dashboard {
  const updatedDashboard = structuredClone(dashboard);

  if (
    !dashboard.configuration.widgets ||
    !dashboard.configuration.widgets.length
  ) {
    return dashboard;
  }

  const updatedWidgets = dashboard.configuration.widgets.map((widget) => {
    if (widget.type === 'data') {
      const query = (widget as DataWidget<ChartType>)?.query;
      const filters = query?.filters;

      if (!query || !filters || filters.length <= 1) {
        return widget;
      }

      const [rootFilter, ...andFilters] = filters;

      return {
        ...widget,
        query: {
          ...query,
          filters: [
            {
              ...rootFilter,
              and: andFilters.length ? [...andFilters] : undefined,
            },
          ],
        },
      } as DataWidget<ChartType>;
    }

    return widget;
  });

  updatedDashboard.configuration = { widgets: updatedWidgets };

  return updatedDashboard;
}
